import { Component, OnInit } from '@angular/core';
import { SUPPORT_EMAIL } from '@core/constants';

@Component({
  selector: 'app-notification-message-pop-up',
  templateUrl: './notification-message-pop-up.component.html',
  styleUrls: ['./notification-message-pop-up.component.scss']
})
export class NotificationMessagePopUpComponent implements OnInit {
  supportEmail = SUPPORT_EMAIL;

  constructor() {}

  ngOnInit(): void {}
}
